import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { guaranteeSection } from '../data/content';
import { siteConfig } from '../data/siteConfig';
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-sage px-5 py-14 md:px-8 md:py-24" data-id="element-97" data-mp="2223jzs07sdfi">
      <Reveal className="mx-auto w-full max-w-2xl" data-id="element-98" data-mp="1x54ob50wjyf7">
        <div className="rounded-xl border border-forest/10 bg-ivory px-6 py-12 text-center shadow-[0_20px_50px_-36px_rgba(16,44,37,0.5)] sm:px-12" data-id="element-99" data-mp="19dzbkyq9dm94">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-brass" data-id="element-100" data-mp="14dl1lb53k28g">
            <ShieldCheckIcon className="h-7 w-7 text-forest" strokeWidth={1.5} aria-hidden="true" data-id="element-101" data-mp="1j6dhm3oddf13" />
          </span>

          <h2 id="guarantee-heading" className="mt-6 font-serif text-[clamp(2rem,4.2vw,3rem)] font-medium leading-[1.1] text-charcoal" data-id="element-102" data-mp="qnzqemxjgraz">
            {guaranteeSection.title}
          </h2>

          <p className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-charcoal/80 md:text-lg" data-id="element-103" data-mp="p0b5jqduz0db">
            {guaranteeSection.body}
          </p>

          <p className="mt-4 text-[15px] font-semibold text-forest" data-id="element-104" data-mp="tw9q12w2fy8g">
            {guaranteeSection.supporting}
          </p>

          {siteConfig.refundPolicyUrl && <a href={siteConfig.refundPolicyUrl} className="mt-6 inline-flex min-h-11 items-center text-[15px] font-semibold text-forest underline decoration-brass underline-offset-4 hover:decoration-forest" data-id="element-105" data-mp="12qeq8cx3am0n">
              Read the refund policy
            </a>}
        </div>
      </Reveal>
    </section>;
}